import { useSelector } from 'react-redux'
import { getAriaLiveLog } from 'redux/reducers/aria-log'

export const AriaLog = () => {
  const ariaLiveLog = useSelector(getAriaLiveLog)
  return (
      <div className='ds-u-visibility--screen-reader'>
        <div role='log'>
          <div aria-live='polite'>
            {ariaLiveLog.messages.map((m) => <p key={m.id}>{m.message}</p>)}
          </div>
        </div>
      </div>
  )
}
